/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BulkUpdateLeadSOffenderRecordsRequest,
  BulkUpdateSourceContactTagsRequest,
  CreateAssignmentRule201Response,
  CreateAssignmentRuleRequest,
  CreateDocumentForLead201Response,
  CreateIntakeIntegration200Response,
  CreateLead201Response,
  CreateLeadAssignment200Response,
  CreateLeadAssignmentRequest,
  CreateLeadComment201Response,
  CreateLeadRequest,
  CreateOrDeleteLeadCommentReaction200Response,
  CreateOrDeleteLeadCommentReactionRequest,
  CreatePccPatient201Response,
  CreatePccPatientRequest,
  CreateSource201Response,
  CreateSourceContact201Response,
  CreateSourceContactTag201Response,
  DeleteLeadAssignment200Response,
  Document,
  FindAdmissionStatusOptions200Response,
  FindAdmissionStatusOptionsRequest,
  FindAllCommentsForLead200Response,
  FindAllIntegrationsByFacilityId200Response,
  FindAllLeadStatuses200Response,
  FindAllLeads200Response,
  FindAllPalIntegrationsByFacilityId200Response,
  FindAllScreenerSources200Response,
  FindAllScreenerSourcesRequest,
  FindAllSourceContactTags200Response,
  FindAllSourceContacts200Response,
  FindAllSpecialCriteria200Response,
  FindHospitalizedInstances200Response,
  FindLeadsBatchWithCommentCounts200Response,
  FindLeadsBatchWithCommentCountsRequest,
  FindLeadsBatchWithDocumentStats200Response,
  FindLeadsBatchWithDocumentStatsRequest,
  FindMedicationsForLead200Response,
  FindOneExecutionsAvailableByFacilityId200Response,
  FindOneIntegrationSettingsByFacilityId200Response,
  FindOnePccAdvancedPatientDetails200Response,
  FindOnePccPatient200Response,
  FindOnePccPendingPatient200Response,
  FindSOffenderRecordsForLead200Response,
  GenerateReport200Response,
  GenerateSOffenderRecordsReport200Response,
  GetPccDemographicsPrefill200Response,
  GetPccPicklist200Response,
  IntegrationCredentials,
  IntegrationSettings,
  Lead,
  LeadComment,
  ListGeneratedReports200Response,
  ListAssignmentRules200Response,
  PatchPccDemographics200Response,
  PatchPccDemographicsRequest,
  PccAdvancedPatientDetails,
  ReadmitToFacility200Response,
  ReadmitToFacilityRequest,
  ReorderAssignmentRulesRequest,
  ReturnToFacilityRequest,
  ScreenerGeneratedDocumentType,
  SetLeadAssignments200Response,
  SetLeadAssignmentsRequest,
  Source,
  SourceConflictErrorResponse,
  SourceContact,
  SourceContactTag,
  Suggestion200Response,
  SuggestionRequest,
  SyncLeadSOffenderRecordsByIdRequest,
  UpdateAdmissionStatusById400Response,
  UpdateAdmissionStatusRequest,
  UpdateAssignmentRuleRequest,
  UpdateLeadAssignmentRequest,
  UpdateLeadDecisionRequest,
  UpdateLeadSOffenderRecordById200Response,
  UpdateLeadSOffenderRecordRequest,
  UpdatePreviousStayRequest,
  UpdateSpecialCriteriaById200Response,
  UpdateSpecialCriteriaByIdRequest,
  UploadPccAdvancedPatientDetails200Response,
  UploadPccPatientDetails200Response,
  UploadPccPatientDetailsRequest,
} from '../models/index';
import {
    BulkUpdateLeadSOffenderRecordsRequestFromJSON,
    BulkUpdateLeadSOffenderRecordsRequestToJSON,
    BulkUpdateSourceContactTagsRequestFromJSON,
    BulkUpdateSourceContactTagsRequestToJSON,
    CreateAssignmentRule201ResponseFromJSON,
    CreateAssignmentRule201ResponseToJSON,
    CreateAssignmentRuleRequestFromJSON,
    CreateAssignmentRuleRequestToJSON,
    CreateDocumentForLead201ResponseFromJSON,
    CreateDocumentForLead201ResponseToJSON,
    CreateIntakeIntegration200ResponseFromJSON,
    CreateIntakeIntegration200ResponseToJSON,
    CreateLead201ResponseFromJSON,
    CreateLead201ResponseToJSON,
    CreateLeadAssignment200ResponseFromJSON,
    CreateLeadAssignment200ResponseToJSON,
    CreateLeadAssignmentRequestFromJSON,
    CreateLeadAssignmentRequestToJSON,
    CreateLeadComment201ResponseFromJSON,
    CreateLeadComment201ResponseToJSON,
    CreateLeadRequestFromJSON,
    CreateLeadRequestToJSON,
    CreateOrDeleteLeadCommentReaction200ResponseFromJSON,
    CreateOrDeleteLeadCommentReaction200ResponseToJSON,
    CreateOrDeleteLeadCommentReactionRequestFromJSON,
    CreateOrDeleteLeadCommentReactionRequestToJSON,
    CreatePccPatient201ResponseFromJSON,
    CreatePccPatient201ResponseToJSON,
    CreatePccPatientRequestFromJSON,
    CreatePccPatientRequestToJSON,
    CreateSource201ResponseFromJSON,
    CreateSource201ResponseToJSON,
    CreateSourceContact201ResponseFromJSON,
    CreateSourceContact201ResponseToJSON,
    CreateSourceContactTag201ResponseFromJSON,
    CreateSourceContactTag201ResponseToJSON,
    DeleteLeadAssignment200ResponseFromJSON,
    DeleteLeadAssignment200ResponseToJSON,
    DocumentFromJSON,
    DocumentToJSON,
    FindAdmissionStatusOptions200ResponseFromJSON,
    FindAdmissionStatusOptions200ResponseToJSON,
    FindAdmissionStatusOptionsRequestFromJSON,
    FindAdmissionStatusOptionsRequestToJSON,
    FindAllCommentsForLead200ResponseFromJSON,
    FindAllCommentsForLead200ResponseToJSON,
    FindAllIntegrationsByFacilityId200ResponseFromJSON,
    FindAllIntegrationsByFacilityId200ResponseToJSON,
    FindAllLeadStatuses200ResponseFromJSON,
    FindAllLeadStatuses200ResponseToJSON,
    FindAllLeads200ResponseFromJSON,
    FindAllLeads200ResponseToJSON,
    FindAllPalIntegrationsByFacilityId200ResponseFromJSON,
    FindAllPalIntegrationsByFacilityId200ResponseToJSON,
    FindAllScreenerSources200ResponseFromJSON,
    FindAllScreenerSources200ResponseToJSON,
    FindAllScreenerSourcesRequestFromJSON,
    FindAllScreenerSourcesRequestToJSON,
    FindAllSourceContactTags200ResponseFromJSON,
    FindAllSourceContactTags200ResponseToJSON,
    FindAllSourceContacts200ResponseFromJSON,
    FindAllSourceContacts200ResponseToJSON,
    FindAllSpecialCriteria200ResponseFromJSON,
    FindAllSpecialCriteria200ResponseToJSON,
    FindHospitalizedInstances200ResponseFromJSON,
    FindHospitalizedInstances200ResponseToJSON,
    FindLeadsBatchWithCommentCounts200ResponseFromJSON,
    FindLeadsBatchWithCommentCounts200ResponseToJSON,
    FindLeadsBatchWithCommentCountsRequestFromJSON,
    FindLeadsBatchWithCommentCountsRequestToJSON,
    FindLeadsBatchWithDocumentStats200ResponseFromJSON,
    FindLeadsBatchWithDocumentStats200ResponseToJSON,
    FindLeadsBatchWithDocumentStatsRequestFromJSON,
    FindLeadsBatchWithDocumentStatsRequestToJSON,
    FindMedicationsForLead200ResponseFromJSON,
    FindMedicationsForLead200ResponseToJSON,
    FindOneExecutionsAvailableByFacilityId200ResponseFromJSON,
    FindOneExecutionsAvailableByFacilityId200ResponseToJSON,
    FindOneIntegrationSettingsByFacilityId200ResponseFromJSON,
    FindOneIntegrationSettingsByFacilityId200ResponseToJSON,
    FindOnePccAdvancedPatientDetails200ResponseFromJSON,
    FindOnePccAdvancedPatientDetails200ResponseToJSON,
    FindOnePccPatient200ResponseFromJSON,
    FindOnePccPatient200ResponseToJSON,
    FindOnePccPendingPatient200ResponseFromJSON,
    FindOnePccPendingPatient200ResponseToJSON,
    FindSOffenderRecordsForLead200ResponseFromJSON,
    FindSOffenderRecordsForLead200ResponseToJSON,
    GenerateReport200ResponseFromJSON,
    GenerateReport200ResponseToJSON,
    GenerateSOffenderRecordsReport200ResponseFromJSON,
    GenerateSOffenderRecordsReport200ResponseToJSON,
    GetPccDemographicsPrefill200ResponseFromJSON,
    GetPccDemographicsPrefill200ResponseToJSON,
    GetPccPicklist200ResponseFromJSON,
    GetPccPicklist200ResponseToJSON,
    IntegrationCredentialsFromJSON,
    IntegrationCredentialsToJSON,
    IntegrationSettingsFromJSON,
    IntegrationSettingsToJSON,
    LeadFromJSON,
    LeadToJSON,
    LeadCommentFromJSON,
    LeadCommentToJSON,
    ListGeneratedReports200ResponseFromJSON,
    ListGeneratedReports200ResponseToJSON,
    ListAssignmentRules200ResponseFromJSON,
    ListAssignmentRules200ResponseToJSON,
    PatchPccDemographics200ResponseFromJSON,
    PatchPccDemographics200ResponseToJSON,
    PatchPccDemographicsRequestFromJSON,
    PatchPccDemographicsRequestToJSON,
    PccAdvancedPatientDetailsFromJSON,
    PccAdvancedPatientDetailsToJSON,
    ReadmitToFacility200ResponseFromJSON,
    ReadmitToFacility200ResponseToJSON,
    ReadmitToFacilityRequestFromJSON,
    ReadmitToFacilityRequestToJSON,
    ReorderAssignmentRulesRequestFromJSON,
    ReorderAssignmentRulesRequestToJSON,
    ReturnToFacilityRequestFromJSON,
    ReturnToFacilityRequestToJSON,
    ScreenerGeneratedDocumentTypeFromJSON,
    ScreenerGeneratedDocumentTypeToJSON,
    SetLeadAssignments200ResponseFromJSON,
    SetLeadAssignments200ResponseToJSON,
    SetLeadAssignmentsRequestFromJSON,
    SetLeadAssignmentsRequestToJSON,
    SourceFromJSON,
    SourceToJSON,
    SourceConflictErrorResponseFromJSON,
    SourceConflictErrorResponseToJSON,
    SourceContactFromJSON,
    SourceContactToJSON,
    SourceContactTagFromJSON,
    SourceContactTagToJSON,
    Suggestion200ResponseFromJSON,
    Suggestion200ResponseToJSON,
    SuggestionRequestFromJSON,
    SuggestionRequestToJSON,
    SyncLeadSOffenderRecordsByIdRequestFromJSON,
    SyncLeadSOffenderRecordsByIdRequestToJSON,
    UpdateAdmissionStatusById400ResponseFromJSON,
    UpdateAdmissionStatusById400ResponseToJSON,
    UpdateAdmissionStatusRequestFromJSON,
    UpdateAdmissionStatusRequestToJSON,
    UpdateAssignmentRuleRequestFromJSON,
    UpdateAssignmentRuleRequestToJSON,
    UpdateLeadAssignmentRequestFromJSON,
    UpdateLeadAssignmentRequestToJSON,
    UpdateLeadDecisionRequestFromJSON,
    UpdateLeadDecisionRequestToJSON,
    UpdateLeadSOffenderRecordById200ResponseFromJSON,
    UpdateLeadSOffenderRecordById200ResponseToJSON,
    UpdateLeadSOffenderRecordRequestFromJSON,
    UpdateLeadSOffenderRecordRequestToJSON,
    UpdatePreviousStayRequestFromJSON,
    UpdatePreviousStayRequestToJSON,
    UpdateSpecialCriteriaById200ResponseFromJSON,
    UpdateSpecialCriteriaById200ResponseToJSON,
    UpdateSpecialCriteriaByIdRequestFromJSON,
    UpdateSpecialCriteriaByIdRequestToJSON,
    UploadPccAdvancedPatientDetails200ResponseFromJSON,
    UploadPccAdvancedPatientDetails200ResponseToJSON,
    UploadPccPatientDetails200ResponseFromJSON,
    UploadPccPatientDetails200ResponseToJSON,
    UploadPccPatientDetailsRequestFromJSON,
    UploadPccPatientDetailsRequestToJSON,
} from '../models/index';

export interface BulkUpdateLeadSOffenderRecordsOperationRequest {
    leadId: string;
    bulkUpdateLeadSOffenderRecordsRequest: BulkUpdateLeadSOffenderRecordsRequest;
}

export interface BulkUpdateSourceContactTagsOperationRequest {
    bulkUpdateSourceContactTagsRequest: BulkUpdateSourceContactTagsRequest;
}

export interface CancelLeadByIdRequest {
    leadId: string;
}

export interface ClaimLeadByIdRequest {
    leadId: string;
}

export interface CreateAssignmentRuleOperationRequest {
    createAssignmentRuleRequest: CreateAssignmentRuleRequest;
}

export interface CreateDocumentForLeadRequest {
    leadId: string;
    document: Document;
}

export interface CreateIntakeIntegrationRequest {
    facilityId: string;
    integrationCredentials: IntegrationCredentials;
}

export interface CreateLeadOperationRequest {
    createLeadRequest: CreateLeadRequest;
}

export interface CreateLeadAssignmentOperationRequest {
    leadId: string;
    createLeadAssignmentRequest: CreateLeadAssignmentRequest;
}

export interface CreateLeadCommentRequest {
    leadId: string;
    leadComment: LeadComment;
}

export interface CreateOrDeleteLeadCommentReactionOperationRequest {
    commentId: string;
    createOrDeleteLeadCommentReactionRequest: CreateOrDeleteLeadCommentReactionRequest;
}

export interface CreatePccPatientOperationRequest {
    leadId: string;
    createPccPatientRequest: CreatePccPatientRequest;
}

export interface CreateSourceRequest {
    source: Source;
}

export interface CreateSourceContactRequest {
    sourceContact: SourceContact;
}

export interface CreateSourceContactTagRequest {
    sourceContactTag: SourceContactTag;
}

export interface DeleteAssignmentRuleRequest {
    ruleId: string;
}

export interface DeleteDocumentForLeadRequest {
    leadId: string;
    documentId: string;
}

export interface DeleteLeadAssignmentRequest {
    leadId: string;
    assignmentId: string;
}

export interface DeleteLeadByIdRequest {
    leadId: string;
}

export interface DeleteLeadCommentByIdRequest {
    commentId: string;
}

export interface DeleteSourceByIdRequest {
    sourceId: string;
}

export interface DeleteSourceContactByIdRequest {
    contactId: string;
}

export interface DeleteSourceContactTagByIdRequest {
    tagId: string;
}

export interface EvaluateLeadByIdRequest {
    leadId: string;
}

export interface FindAdmissionStatusOptionsOperationRequest {
    findAdmissionStatusOptionsRequest: FindAdmissionStatusOptionsRequest;
}

export interface FindAllCommentsForLeadRequest {
    leadId: string;
}

export interface FindAllIntegrationsByFacilityIdRequest {
    facilityId: string;
}

export interface FindAllLeadsRequest {
    facilityId?: string;
    sourceId?: string;
    search?: string;
    limit?: number;
    page?: number;
    suggestion?: string;
    includeCancelled?: boolean;
    includeOtherFacilityDuplicates?: boolean;
    connector?: string;
    admissionStatus?: string;
    payerType?: string;
    payer?: string;
    payerSource?: string;
    includeNullPayerType?: boolean;
    includeNullPayerSource?: boolean;
    networkStatus?: string;
    pccStatus?: string;
    matrixCareStatus?: string;
    statusId?: string;
    reviewStageAcceptSource?: FindAllLeadsReviewStageAcceptSourceEnum;
    includeEmptyAdmission?: boolean;
    hasNewHospitalMessages?: boolean;
    hasNewDocuments?: boolean;
    assigneeUserIds?: string;
    unassigned?: boolean;
}

export interface FindAllPalIntegrationsByFacilityIdRequest {
    facilityId: string;
}

export interface FindAllScreenerSourcesOperationRequest {
    findAllScreenerSourcesRequest: FindAllScreenerSourcesRequest;
}

export interface FindAllSourceContactsRequest {
    sourceId?: string;
    search?: string;
    limit?: number;
    page?: number;
}

export interface FindAllSpecialCriteriaRequest {
    facilityId: string;
    informational?: boolean;
}

export interface FindHospitalizedInstancesRequest {
    leadId: string;
}

export interface FindLeadByIdRequest {
    leadId: string;
}

export interface FindLeadsBatchWithCommentCountsOperationRequest {
    findLeadsBatchWithCommentCountsRequest: FindLeadsBatchWithCommentCountsRequest;
}

export interface FindLeadsBatchWithDocumentStatsOperationRequest {
    findLeadsBatchWithDocumentStatsRequest: FindLeadsBatchWithDocumentStatsRequest;
}

export interface FindMedicationsForLeadRequest {
    leadId: string;
}

export interface FindOneExecutionsAvailableByFacilityIdRequest {
    facilityId: string;
}

export interface FindOneIntegrationSettingsByFacilityIdRequest {
    facilityId: string;
}

export interface FindOnePccAdvancedPatientDetailsRequest {
    leadId: string;
}

export interface FindOnePccPatientRequest {
    leadId: string;
}

export interface FindOnePccPendingPatientRequest {
    leadId: string;
}

export interface FindOneSourceRequest {
    sourceId: string;
}

export interface FindReadmissionCandidatesRequest {
    leadId: string;
}

export interface FindSOffenderRecordsForLeadRequest {
    leadId: string;
}

export interface GenerateReportRequest {
    leadId: string;
    reportType: ScreenerGeneratedDocumentType;
    checkId?: string;
}

export interface GetGeneratedReportDownloadUrlRequest {
    leadId: string;
    reportType: ScreenerGeneratedDocumentType;
    checkId?: string;
}

export interface ListGeneratedReportsRequest {
    leadId: string;
}

export interface GenerateSOffenderRecordsReportRequest {
    leadId: string;
}

export interface GetPccDemographicsPrefillRequest {
    leadId: string;
}

export interface GetPccPicklistRequest {
    leadId: string;
}

export interface IgnoreDuplicateCheckForLeadRequest {
    leadId: string;
}

export interface PatchPccDemographicsOperationRequest {
    leadId: string;
    patchPccDemographicsRequest: PatchPccDemographicsRequest;
}

export interface ReadmitToFacilityOperationRequest {
    readmitToFacilityRequest: ReadmitToFacilityRequest;
}

export interface ReorderAssignmentRulesOperationRequest {
    reorderAssignmentRulesRequest: ReorderAssignmentRulesRequest;
}

export interface ReturnToFacilityOperationRequest {
    leadId: string;
    returnToFacilityRequest: ReturnToFacilityRequest;
}

export interface RevertAdmissionStatusByIdRequest {
    leadId: string;
}

export interface SetLeadAssignmentsOperationRequest {
    leadId: string;
    setLeadAssignmentsRequest: SetLeadAssignmentsRequest;
}

export interface SuggestionOperationRequest {
    suggestionRequest: SuggestionRequest;
}

export interface SyncLeadSOffenderRecordsByIdOperationRequest {
    leadId: string;
    syncLeadSOffenderRecordsByIdRequest: SyncLeadSOffenderRecordsByIdRequest;
}

export interface UnclaimLeadByIdRequest {
    leadId: string;
}

export interface UpdateAdmissionStatusByIdRequest {
    leadId: string;
    updateAdmissionStatusRequest: UpdateAdmissionStatusRequest;
}

export interface UpdateAssignmentRuleOperationRequest {
    ruleId: string;
    updateAssignmentRuleRequest: UpdateAssignmentRuleRequest;
}

export interface UpdateDecisionOnLeadByIdRequest {
    leadId: string;
    updateLeadDecisionRequest: UpdateLeadDecisionRequest;
}

export interface UpdateIntegrationSettingsByFacilityIdRequest {
    facilityId: string;
    integrationSettings: IntegrationSettings;
}

export interface UpdateLeadAssignmentOperationRequest {
    leadId: string;
    assignmentId: string;
    updateLeadAssignmentRequest: UpdateLeadAssignmentRequest;
}

export interface UpdateLeadByIdRequest {
    leadId: string;
    lead: Lead;
}

export interface UpdateLeadCommentByIdRequest {
    commentId: string;
    leadComment: LeadComment;
}

export interface UpdateLeadSOffenderRecordByIdRequest {
    sOffenderRecordId: string;
    updateLeadSOffenderRecordRequest: UpdateLeadSOffenderRecordRequest;
}

export interface UpdatePreviousStayByIdRequest {
    leadId: string;
    updatePreviousStayRequest: UpdatePreviousStayRequest;
}

export interface UpdateSourceByIdRequest {
    sourceId: string;
    source: Source;
}

export interface UpdateSourceContactByIdRequest {
    contactId: string;
    sourceContact: SourceContact;
}

export interface UpdateSpecialCriteriaByIdOperationRequest {
    criteriaId: string;
    updateSpecialCriteriaByIdRequest: UpdateSpecialCriteriaByIdRequest;
}

export interface UploadPccAdvancedPatientDetailsRequest {
    leadId: string;
    pccAdvancedPatientDetails: PccAdvancedPatientDetails;
}

export interface UploadPccPatientDetailsOperationRequest {
    leadId: string;
    uploadPccPatientDetailsRequest: UploadPccPatientDetailsRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Bulk update lead s. offender records by IDs
     */
    async bulkUpdateLeadSOffenderRecordsRaw(requestParameters: BulkUpdateLeadSOffenderRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindSOffenderRecordsForLead200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling bulkUpdateLeadSOffenderRecords.');
        }

        if (requestParameters.bulkUpdateLeadSOffenderRecordsRequest === null || requestParameters.bulkUpdateLeadSOffenderRecordsRequest === undefined) {
            throw new runtime.RequiredError('bulkUpdateLeadSOffenderRecordsRequest','Required parameter requestParameters.bulkUpdateLeadSOffenderRecordsRequest was null or undefined when calling bulkUpdateLeadSOffenderRecords.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/s-offender-records/bulk`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateLeadSOffenderRecordsRequestToJSON(requestParameters.bulkUpdateLeadSOffenderRecordsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindSOffenderRecordsForLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Bulk update lead s. offender records by IDs
     */
    async bulkUpdateLeadSOffenderRecords(requestParameters: BulkUpdateLeadSOffenderRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindSOffenderRecordsForLead200Response> {
        const response = await this.bulkUpdateLeadSOffenderRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bulk update screener source contact tags
     */
    async bulkUpdateSourceContactTagsRaw(requestParameters: BulkUpdateSourceContactTagsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllSourceContactTags200Response>> {
        if (requestParameters.bulkUpdateSourceContactTagsRequest === null || requestParameters.bulkUpdateSourceContactTagsRequest === undefined) {
            throw new runtime.RequiredError('bulkUpdateSourceContactTagsRequest','Required parameter requestParameters.bulkUpdateSourceContactTagsRequest was null or undefined when calling bulkUpdateSourceContactTags.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/source-contact-tags`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BulkUpdateSourceContactTagsRequestToJSON(requestParameters.bulkUpdateSourceContactTagsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllSourceContactTags200ResponseFromJSON(jsonValue));
    }

    /**
     * Bulk update screener source contact tags
     */
    async bulkUpdateSourceContactTags(requestParameters: BulkUpdateSourceContactTagsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllSourceContactTags200Response> {
        const response = await this.bulkUpdateSourceContactTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel a screener lead by ID
     */
    async cancelLeadByIdRaw(requestParameters: CancelLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling cancelLeadById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/cancel`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Cancel a screener lead by ID
     */
    async cancelLeadById(requestParameters: CancelLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.cancelLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Claim a screener lead by ID by given facility
     */
    async claimLeadByIdRaw(requestParameters: ClaimLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling claimLeadById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/claim`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Claim a screener lead by ID by given facility
     */
    async claimLeadById(requestParameters: ClaimLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.claimLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an auto-allocation assignment rule
     */
    async createAssignmentRuleRaw(requestParameters: CreateAssignmentRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateAssignmentRule201Response>> {
        if (requestParameters.createAssignmentRuleRequest === null || requestParameters.createAssignmentRuleRequest === undefined) {
            throw new runtime.RequiredError('createAssignmentRuleRequest','Required parameter requestParameters.createAssignmentRuleRequest was null or undefined when calling createAssignmentRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/assignment-rules`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAssignmentRuleRequestToJSON(requestParameters.createAssignmentRuleRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateAssignmentRule201ResponseFromJSON(jsonValue));
    }

    /**
     * Create an auto-allocation assignment rule
     */
    async createAssignmentRule(requestParameters: CreateAssignmentRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateAssignmentRule201Response> {
        const response = await this.createAssignmentRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new document for a screener lead by ID
     */
    async createDocumentForLeadRaw(requestParameters: CreateDocumentForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDocumentForLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createDocumentForLead.');
        }

        if (requestParameters.document === null || requestParameters.document === undefined) {
            throw new runtime.RequiredError('document','Required parameter requestParameters.document was null or undefined when calling createDocumentForLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/documents`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DocumentToJSON(requestParameters.document),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDocumentForLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new document for a screener lead by ID
     */
    async createDocumentForLead(requestParameters: CreateDocumentForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDocumentForLead201Response> {
        const response = await this.createDocumentForLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a facility intake integration credentials
     */
    async createIntakeIntegrationRaw(requestParameters: CreateIntakeIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateIntakeIntegration200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling createIntakeIntegration.');
        }

        if (requestParameters.integrationCredentials === null || requestParameters.integrationCredentials === undefined) {
            throw new runtime.RequiredError('integrationCredentials','Required parameter requestParameters.integrationCredentials was null or undefined when calling createIntakeIntegration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facilities/{facility_id}/integrations`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationCredentialsToJSON(requestParameters.integrationCredentials),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateIntakeIntegration200ResponseFromJSON(jsonValue));
    }

    /**
     * Create a facility intake integration credentials
     */
    async createIntakeIntegration(requestParameters: CreateIntakeIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateIntakeIntegration200Response> {
        const response = await this.createIntakeIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a screener lead
     */
    async createLeadRaw(requestParameters: CreateLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        if (requestParameters.createLeadRequest === null || requestParameters.createLeadRequest === undefined) {
            throw new runtime.RequiredError('createLeadRequest','Required parameter requestParameters.createLeadRequest was null or undefined when calling createLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeadRequestToJSON(requestParameters.createLeadRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener lead
     */
    async createLead(requestParameters: CreateLeadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.createLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Assign a user to a referral as Owner or Source Liaison
     */
    async createLeadAssignmentRaw(requestParameters: CreateLeadAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadAssignment200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createLeadAssignment.');
        }

        if (requestParameters.createLeadAssignmentRequest === null || requestParameters.createLeadAssignmentRequest === undefined) {
            throw new runtime.RequiredError('createLeadAssignmentRequest','Required parameter requestParameters.createLeadAssignmentRequest was null or undefined when calling createLeadAssignment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/assignments`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLeadAssignmentRequestToJSON(requestParameters.createLeadAssignmentRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadAssignment200ResponseFromJSON(jsonValue));
    }

    /**
     * Assign a user to a referral as Owner or Source Liaison
     */
    async createLeadAssignment(requestParameters: CreateLeadAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadAssignment200Response> {
        const response = await this.createLeadAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a lead comment
     */
    async createLeadCommentRaw(requestParameters: CreateLeadCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadComment201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createLeadComment.');
        }

        if (requestParameters.leadComment === null || requestParameters.leadComment === undefined) {
            throw new runtime.RequiredError('leadComment','Required parameter requestParameters.leadComment was null or undefined when calling createLeadComment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/comments`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LeadCommentToJSON(requestParameters.leadComment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadComment201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a lead comment
     */
    async createLeadComment(requestParameters: CreateLeadCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadComment201Response> {
        const response = await this.createLeadCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create a new reaction
     */
    async createOrDeleteLeadCommentReactionRaw(requestParameters: CreateOrDeleteLeadCommentReactionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrDeleteLeadCommentReaction200Response>> {
        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling createOrDeleteLeadCommentReaction.');
        }

        if (requestParameters.createOrDeleteLeadCommentReactionRequest === null || requestParameters.createOrDeleteLeadCommentReactionRequest === undefined) {
            throw new runtime.RequiredError('createOrDeleteLeadCommentReactionRequest','Required parameter requestParameters.createOrDeleteLeadCommentReactionRequest was null or undefined when calling createOrDeleteLeadCommentReaction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/lead-comments/{comment_id}/reactions`.replace(`{${"comment_id"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrDeleteLeadCommentReactionRequestToJSON(requestParameters.createOrDeleteLeadCommentReactionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOrDeleteLeadCommentReaction200ResponseFromJSON(jsonValue));
    }

    /**
     * create a new reaction
     */
    async createOrDeleteLeadCommentReaction(requestParameters: CreateOrDeleteLeadCommentReactionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrDeleteLeadCommentReaction200Response> {
        const response = await this.createOrDeleteLeadCommentReactionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a PCC patient
     */
    async createPccPatientRaw(requestParameters: CreatePccPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePccPatient201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling createPccPatient.');
        }

        if (requestParameters.createPccPatientRequest === null || requestParameters.createPccPatientRequest === undefined) {
            throw new runtime.RequiredError('createPccPatientRequest','Required parameter requestParameters.createPccPatientRequest was null or undefined when calling createPccPatient.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/pcc/patients`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePccPatientRequestToJSON(requestParameters.createPccPatientRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePccPatient201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a PCC patient
     */
    async createPccPatient(requestParameters: CreatePccPatientOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePccPatient201Response> {
        const response = await this.createPccPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a source
     */
    async createSourceRaw(requestParameters: CreateSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSource201Response>> {
        if (requestParameters.source === null || requestParameters.source === undefined) {
            throw new runtime.RequiredError('source','Required parameter requestParameters.source was null or undefined when calling createSource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/sources`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SourceToJSON(requestParameters.source),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSource201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a source
     */
    async createSource(requestParameters: CreateSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSource201Response> {
        const response = await this.createSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a screener source contact
     */
    async createSourceContactRaw(requestParameters: CreateSourceContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSourceContact201Response>> {
        if (requestParameters.sourceContact === null || requestParameters.sourceContact === undefined) {
            throw new runtime.RequiredError('sourceContact','Required parameter requestParameters.sourceContact was null or undefined when calling createSourceContact.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/source-contacts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SourceContactToJSON(requestParameters.sourceContact),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSourceContact201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener source contact
     */
    async createSourceContact(requestParameters: CreateSourceContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSourceContact201Response> {
        const response = await this.createSourceContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a screener source contact tag
     */
    async createSourceContactTagRaw(requestParameters: CreateSourceContactTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSourceContactTag201Response>> {
        if (requestParameters.sourceContactTag === null || requestParameters.sourceContactTag === undefined) {
            throw new runtime.RequiredError('sourceContactTag','Required parameter requestParameters.sourceContactTag was null or undefined when calling createSourceContactTag.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/source-contact-tags`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SourceContactTagToJSON(requestParameters.sourceContactTag),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSourceContactTag201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a screener source contact tag
     */
    async createSourceContactTag(requestParameters: CreateSourceContactTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSourceContactTag201Response> {
        const response = await this.createSourceContactTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an auto-allocation assignment rule
     */
    async deleteAssignmentRuleRaw(requestParameters: DeleteAssignmentRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.ruleId === null || requestParameters.ruleId === undefined) {
            throw new runtime.RequiredError('ruleId','Required parameter requestParameters.ruleId was null or undefined when calling deleteAssignmentRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/assignment-rules/{rule_id}`.replace(`{${"rule_id"}}`, encodeURIComponent(String(requestParameters.ruleId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an auto-allocation assignment rule
     */
    async deleteAssignmentRule(requestParameters: DeleteAssignmentRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssignmentRuleRaw(requestParameters, initOverrides);
    }

    /**
     * Delete document for a screener lead by ID
     */
    async deleteDocumentForLeadRaw(requestParameters: DeleteDocumentForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling deleteDocumentForLead.');
        }

        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling deleteDocumentForLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/documents/{document_id}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"document_id"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete document for a screener lead by ID
     */
    async deleteDocumentForLead(requestParameters: DeleteDocumentForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDocumentForLeadRaw(requestParameters, initOverrides);
    }

    /**
     * Remove an assignment from a referral
     */
    async deleteLeadAssignmentRaw(requestParameters: DeleteLeadAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteLeadAssignment200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling deleteLeadAssignment.');
        }

        if (requestParameters.assignmentId === null || requestParameters.assignmentId === undefined) {
            throw new runtime.RequiredError('assignmentId','Required parameter requestParameters.assignmentId was null or undefined when calling deleteLeadAssignment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/assignments/{assignment_id}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"assignment_id"}}`, encodeURIComponent(String(requestParameters.assignmentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteLeadAssignment200ResponseFromJSON(jsonValue));
    }

    /**
     * Remove an assignment from a referral
     */
    async deleteLeadAssignment(requestParameters: DeleteLeadAssignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteLeadAssignment200Response> {
        const response = await this.deleteLeadAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a screener lead by ID
     */
    async deleteLeadByIdRaw(requestParameters: DeleteLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling deleteLeadById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener lead by ID
     */
    async deleteLeadById(requestParameters: DeleteLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLeadByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a screener lead comment by ID
     */
    async deleteLeadCommentByIdRaw(requestParameters: DeleteLeadCommentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling deleteLeadCommentById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/lead-comments/{comment_id}`.replace(`{${"comment_id"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener lead comment by ID
     */
    async deleteLeadCommentById(requestParameters: DeleteLeadCommentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLeadCommentByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a screener source by ID and all attached contacts
     */
    async deleteSourceByIdRaw(requestParameters: DeleteSourceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) {
            throw new runtime.RequiredError('sourceId','Required parameter requestParameters.sourceId was null or undefined when calling deleteSourceById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sources/{source_id}`.replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.sourceId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener source by ID and all attached contacts
     */
    async deleteSourceById(requestParameters: DeleteSourceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSourceByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a screener source contact by ID
     */
    async deleteSourceContactByIdRaw(requestParameters: DeleteSourceContactByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.contactId === null || requestParameters.contactId === undefined) {
            throw new runtime.RequiredError('contactId','Required parameter requestParameters.contactId was null or undefined when calling deleteSourceContactById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/source-contacts/{contact_id}`.replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contactId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener source contact by ID
     */
    async deleteSourceContactById(requestParameters: DeleteSourceContactByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSourceContactByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a screener source contact tag by ID
     */
    async deleteSourceContactTagByIdRaw(requestParameters: DeleteSourceContactTagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.tagId === null || requestParameters.tagId === undefined) {
            throw new runtime.RequiredError('tagId','Required parameter requestParameters.tagId was null or undefined when calling deleteSourceContactTagById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/source-contact-tags/{tag_id}`.replace(`{${"tag_id"}}`, encodeURIComponent(String(requestParameters.tagId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a screener source contact tag by ID
     */
    async deleteSourceContactTagById(requestParameters: DeleteSourceContactTagByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSourceContactTagByIdRaw(requestParameters, initOverrides);
    }

    /**
     * Trigger a screener lead evaluation by ID
     */
    async evaluateLeadByIdRaw(requestParameters: EvaluateLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling evaluateLeadById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/evaluate`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Trigger a screener lead evaluation by ID
     */
    async evaluateLeadById(requestParameters: EvaluateLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.evaluateLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the admission-status options (forward + revert) for a batch of leads
     */
    async findAdmissionStatusOptionsRaw(requestParameters: FindAdmissionStatusOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAdmissionStatusOptions200Response>> {
        if (requestParameters.findAdmissionStatusOptionsRequest === null || requestParameters.findAdmissionStatusOptionsRequest === undefined) {
            throw new runtime.RequiredError('findAdmissionStatusOptionsRequest','Required parameter requestParameters.findAdmissionStatusOptionsRequest was null or undefined when calling findAdmissionStatusOptions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/admission-status-options`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindAdmissionStatusOptionsRequestToJSON(requestParameters.findAdmissionStatusOptionsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAdmissionStatusOptions200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the admission-status options (forward + revert) for a batch of leads
     */
    async findAdmissionStatusOptions(requestParameters: FindAdmissionStatusOptionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAdmissionStatusOptions200Response> {
        const response = await this.findAdmissionStatusOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get comments for a screener lead
     */
    async findAllCommentsForLeadRaw(requestParameters: FindAllCommentsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllCommentsForLead200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findAllCommentsForLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/comments`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllCommentsForLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Get comments for a screener lead
     */
    async findAllCommentsForLead(requestParameters: FindAllCommentsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllCommentsForLead200Response> {
        const response = await this.findAllCommentsForLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get screener integrations for facility
     */
    async findAllIntegrationsByFacilityIdRaw(requestParameters: FindAllIntegrationsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllIntegrationsByFacilityId200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllIntegrationsByFacilityId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facilities/{facility_id}/integrations`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllIntegrationsByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Get screener integrations for facility
     */
    async findAllIntegrationsByFacilityId(requestParameters: FindAllIntegrationsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllIntegrationsByFacilityId200Response> {
        const response = await this.findAllIntegrationsByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all screener lead statuses
     */
    async findAllLeadStatusesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllLeadStatuses200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/lead-statuses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllLeadStatuses200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener lead statuses
     */
    async findAllLeadStatuses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllLeadStatuses200Response> {
        const response = await this.findAllLeadStatusesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all screener leads
     */
    async findAllLeadsRaw(requestParameters: FindAllLeadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllLeads200Response>> {
        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.sourceId !== undefined) {
            queryParameters['source_id'] = requestParameters.sourceId;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.suggestion !== undefined) {
            queryParameters['suggestion'] = requestParameters.suggestion;
        }

        if (requestParameters.includeCancelled !== undefined) {
            queryParameters['include_cancelled'] = requestParameters.includeCancelled;
        }

        if (requestParameters.includeOtherFacilityDuplicates !== undefined) {
            queryParameters['include_other_facility_duplicates'] = requestParameters.includeOtherFacilityDuplicates;
        }

        if (requestParameters.connector !== undefined) {
            queryParameters['connector'] = requestParameters.connector;
        }

        if (requestParameters.admissionStatus !== undefined) {
            queryParameters['admission_status'] = requestParameters.admissionStatus;
        }

        if (requestParameters.payerType !== undefined) {
            queryParameters['payer_type'] = requestParameters.payerType;
        }

        if (requestParameters.payer !== undefined) {
            queryParameters['payer'] = requestParameters.payer;
        }

        if (requestParameters.payerSource !== undefined) {
            queryParameters['payer_source'] = requestParameters.payerSource;
        }

        if (requestParameters.includeNullPayerType !== undefined) {
            queryParameters['include_null_payer_type'] = requestParameters.includeNullPayerType;
        }

        if (requestParameters.includeNullPayerSource !== undefined) {
            queryParameters['include_null_payer_source'] = requestParameters.includeNullPayerSource;
        }

        if (requestParameters.networkStatus !== undefined) {
            queryParameters['network_status'] = requestParameters.networkStatus;
        }

        if (requestParameters.pccStatus !== undefined) {
            queryParameters['pcc_status'] = requestParameters.pccStatus;
        }

        if (requestParameters.matrixCareStatus !== undefined) {
            queryParameters['matrix_care_status'] = requestParameters.matrixCareStatus;
        }

        if (requestParameters.statusId !== undefined) {
            queryParameters['status_id'] = requestParameters.statusId;
        }

        if (requestParameters.reviewStageAcceptSource !== undefined) {
            queryParameters['review_stage_accept_source'] = requestParameters.reviewStageAcceptSource;
        }

        if (requestParameters.includeEmptyAdmission !== undefined) {
            queryParameters['include_empty_admission'] = requestParameters.includeEmptyAdmission;
        }

        if (requestParameters.hasNewHospitalMessages !== undefined) {
            queryParameters['has_new_hospital_messages'] = requestParameters.hasNewHospitalMessages;
        }

        if (requestParameters.hasNewDocuments !== undefined) {
            queryParameters['has_new_documents'] = requestParameters.hasNewDocuments;
        }

        if (requestParameters.assigneeUserIds !== undefined) {
            queryParameters['assignee_user_ids'] = requestParameters.assigneeUserIds;
        }

        if (requestParameters.unassigned !== undefined) {
            queryParameters['unassigned'] = requestParameters.unassigned;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllLeads200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener leads
     */
    async findAllLeads(requestParameters: FindAllLeadsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllLeads200Response> {
        const response = await this.findAllLeadsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get PAL integrations for facility
     */
    async findAllPalIntegrationsByFacilityIdRaw(requestParameters: FindAllPalIntegrationsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllPalIntegrationsByFacilityId200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllPalIntegrationsByFacilityId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facilities/{facility_id}/pal-integrations`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllPalIntegrationsByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Get PAL integrations for facility
     */
    async findAllPalIntegrationsByFacilityId(requestParameters: FindAllPalIntegrationsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllPalIntegrationsByFacilityId200Response> {
        const response = await this.findAllPalIntegrationsByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all sources
     */
    async findAllScreenerSourcesRaw(requestParameters: FindAllScreenerSourcesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllScreenerSources200Response>> {
        if (requestParameters.findAllScreenerSourcesRequest === null || requestParameters.findAllScreenerSourcesRequest === undefined) {
            throw new runtime.RequiredError('findAllScreenerSourcesRequest','Required parameter requestParameters.findAllScreenerSourcesRequest was null or undefined when calling findAllScreenerSources.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/sources/find-all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindAllScreenerSourcesRequestToJSON(requestParameters.findAllScreenerSourcesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllScreenerSources200ResponseFromJSON(jsonValue));
    }

    /**
     * Find all sources
     */
    async findAllScreenerSources(requestParameters: FindAllScreenerSourcesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllScreenerSources200Response> {
        const response = await this.findAllScreenerSourcesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all screener source contact tags
     */
    async findAllSourceContactTagsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllSourceContactTags200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/source-contact-tags`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllSourceContactTags200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener source contact tags
     */
    async findAllSourceContactTags(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllSourceContactTags200Response> {
        const response = await this.findAllSourceContactTagsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all screener source contacts
     */
    async findAllSourceContactsRaw(requestParameters: FindAllSourceContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllSourceContacts200Response>> {
        const queryParameters: any = {};

        if (requestParameters.sourceId !== undefined) {
            queryParameters['source_id'] = requestParameters.sourceId;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/source-contacts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllSourceContacts200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all screener source contacts
     */
    async findAllSourceContacts(requestParameters: FindAllSourceContactsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllSourceContacts200Response> {
        const response = await this.findAllSourceContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all special criteria by facility_id
     */
    async findAllSpecialCriteriaRaw(requestParameters: FindAllSpecialCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllSpecialCriteria200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findAllSpecialCriteria.');
        }

        const queryParameters: any = {};

        if (requestParameters.facilityId !== undefined) {
            queryParameters['facility_id'] = requestParameters.facilityId;
        }

        if (requestParameters.informational !== undefined) {
            queryParameters['informational'] = requestParameters.informational;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/special-criteria`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllSpecialCriteria200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all special criteria by facility_id
     */
    async findAllSpecialCriteria(requestParameters: FindAllSpecialCriteriaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllSpecialCriteria200Response> {
        const response = await this.findAllSpecialCriteriaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find hospitalized instances in the same duplicate group and facility
     */
    async findHospitalizedInstancesRaw(requestParameters: FindHospitalizedInstancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindHospitalizedInstances200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findHospitalizedInstances.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/hospitalized-instances`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindHospitalizedInstances200ResponseFromJSON(jsonValue));
    }

    /**
     * Find hospitalized instances in the same duplicate group and facility
     */
    async findHospitalizedInstances(requestParameters: FindHospitalizedInstancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindHospitalizedInstances200Response> {
        const response = await this.findHospitalizedInstancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a screener lead by ID
     */
    async findLeadByIdRaw(requestParameters: FindLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findLeadById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Get a screener lead by ID
     */
    async findLeadById(requestParameters: FindLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.findLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get comment counts for multiple leads
     */
    async findLeadsBatchWithCommentCountsRaw(requestParameters: FindLeadsBatchWithCommentCountsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindLeadsBatchWithCommentCounts200Response>> {
        if (requestParameters.findLeadsBatchWithCommentCountsRequest === null || requestParameters.findLeadsBatchWithCommentCountsRequest === undefined) {
            throw new runtime.RequiredError('findLeadsBatchWithCommentCountsRequest','Required parameter requestParameters.findLeadsBatchWithCommentCountsRequest was null or undefined when calling findLeadsBatchWithCommentCounts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/batch/comment-counts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindLeadsBatchWithCommentCountsRequestToJSON(requestParameters.findLeadsBatchWithCommentCountsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindLeadsBatchWithCommentCounts200ResponseFromJSON(jsonValue));
    }

    /**
     * Get comment counts for multiple leads
     */
    async findLeadsBatchWithCommentCounts(requestParameters: FindLeadsBatchWithCommentCountsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindLeadsBatchWithCommentCounts200Response> {
        const response = await this.findLeadsBatchWithCommentCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get document stats for multiple leads
     */
    async findLeadsBatchWithDocumentStatsRaw(requestParameters: FindLeadsBatchWithDocumentStatsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindLeadsBatchWithDocumentStats200Response>> {
        if (requestParameters.findLeadsBatchWithDocumentStatsRequest === null || requestParameters.findLeadsBatchWithDocumentStatsRequest === undefined) {
            throw new runtime.RequiredError('findLeadsBatchWithDocumentStatsRequest','Required parameter requestParameters.findLeadsBatchWithDocumentStatsRequest was null or undefined when calling findLeadsBatchWithDocumentStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/batch/document-stats`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindLeadsBatchWithDocumentStatsRequestToJSON(requestParameters.findLeadsBatchWithDocumentStatsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindLeadsBatchWithDocumentStats200ResponseFromJSON(jsonValue));
    }

    /**
     * Get document stats for multiple leads
     */
    async findLeadsBatchWithDocumentStats(requestParameters: FindLeadsBatchWithDocumentStatsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindLeadsBatchWithDocumentStats200Response> {
        const response = await this.findLeadsBatchWithDocumentStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get medications for a screener lead
     */
    async findMedicationsForLeadRaw(requestParameters: FindMedicationsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindMedicationsForLead200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findMedicationsForLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/medications`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindMedicationsForLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Get medications for a screener lead
     */
    async findMedicationsForLead(requestParameters: FindMedicationsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindMedicationsForLead200Response> {
        const response = await this.findMedicationsForLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get screener executions available for a facility
     */
    async findOneExecutionsAvailableByFacilityIdRaw(requestParameters: FindOneExecutionsAvailableByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneExecutionsAvailableByFacilityId200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findOneExecutionsAvailableByFacilityId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facilities/{facility_id}/executions-available`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneExecutionsAvailableByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Get screener executions available for a facility
     */
    async findOneExecutionsAvailableByFacilityId(requestParameters: FindOneExecutionsAvailableByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneExecutionsAvailableByFacilityId200Response> {
        const response = await this.findOneExecutionsAvailableByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get screener integration settings for facility
     */
    async findOneIntegrationSettingsByFacilityIdRaw(requestParameters: FindOneIntegrationSettingsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneIntegrationSettingsByFacilityId200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling findOneIntegrationSettingsByFacilityId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/facilities/{facility_id}/integrations/settings`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneIntegrationSettingsByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Get screener integration settings for facility
     */
    async findOneIntegrationSettingsByFacilityId(requestParameters: FindOneIntegrationSettingsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneIntegrationSettingsByFacilityId200Response> {
        const response = await this.findOneIntegrationSettingsByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find One PCC advanced patient\'s details
     */
    async findOnePccAdvancedPatientDetailsRaw(requestParameters: FindOnePccAdvancedPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOnePccAdvancedPatientDetails200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findOnePccAdvancedPatientDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/pcc/patient/details/advanced`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOnePccAdvancedPatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Find One PCC advanced patient\'s details
     */
    async findOnePccAdvancedPatientDetails(requestParameters: FindOnePccAdvancedPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOnePccAdvancedPatientDetails200Response> {
        const response = await this.findOnePccAdvancedPatientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find patient by lead ID
     */
    async findOnePccPatientRaw(requestParameters: FindOnePccPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOnePccPatient200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findOnePccPatient.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/pcc/patients`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOnePccPatient200ResponseFromJSON(jsonValue));
    }

    /**
     * Find patient by lead ID
     */
    async findOnePccPatient(requestParameters: FindOnePccPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOnePccPatient200Response> {
        const response = await this.findOnePccPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find pending patient by lead ID
     */
    async findOnePccPendingPatientRaw(requestParameters: FindOnePccPendingPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOnePccPendingPatient200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findOnePccPendingPatient.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/pcc/pending-patients`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOnePccPendingPatient200ResponseFromJSON(jsonValue));
    }

    /**
     * Find pending patient by lead ID
     */
    async findOnePccPendingPatient(requestParameters: FindOnePccPendingPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOnePccPendingPatient200Response> {
        const response = await this.findOnePccPendingPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one screener source
     */
    async findOneSourceRaw(requestParameters: FindOneSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSource201Response>> {
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) {
            throw new runtime.RequiredError('sourceId','Required parameter requestParameters.sourceId was null or undefined when calling findOneSource.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sources/{source_id}`.replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.sourceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSource201ResponseFromJSON(jsonValue));
    }

    /**
     * Get one screener source
     */
    async findOneSource(requestParameters: FindOneSourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSource201Response> {
        const response = await this.findOneSourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find readmission candidates in the same duplicate group and facility
     */
    async findReadmissionCandidatesRaw(requestParameters: FindReadmissionCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindHospitalizedInstances200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findReadmissionCandidates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/readmission-candidates`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindHospitalizedInstances200ResponseFromJSON(jsonValue));
    }

    /**
     * Find readmission candidates in the same duplicate group and facility
     */
    async findReadmissionCandidates(requestParameters: FindReadmissionCandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindHospitalizedInstances200Response> {
        const response = await this.findReadmissionCandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get s offender records for a screener lead
     */
    async findSOffenderRecordsForLeadRaw(requestParameters: FindSOffenderRecordsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindSOffenderRecordsForLead200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling findSOffenderRecordsForLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/s-offender-records`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindSOffenderRecordsForLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Get s offender records for a screener lead
     */
    async findSOffenderRecordsForLead(requestParameters: FindSOffenderRecordsForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindSOffenderRecordsForLead200Response> {
        const response = await this.findSOffenderRecordsForLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generate any type of report for a screener lead synchronously. Throws an error if the report is not yet available.
     * Generate a report for a screener lead
     */
    async generateReportRaw(requestParameters: GenerateReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateReport200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling generateReport.');
        }

        if (requestParameters.reportType === null || requestParameters.reportType === undefined) {
            throw new runtime.RequiredError('reportType','Required parameter requestParameters.reportType was null or undefined when calling generateReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.checkId !== undefined) {
            queryParameters['check_id'] = requestParameters.checkId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/generated-reports/{report_type}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"report_type"}}`, encodeURIComponent(String(requestParameters.reportType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateReport200ResponseFromJSON(jsonValue));
    }

    /**
     * Generate any type of report for a screener lead synchronously. Throws an error if the report is not yet available.
     * Generate a report for a screener lead
     */
    async generateReport(requestParameters: GenerateReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateReport200Response> {
        const response = await this.generateReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Signs and returns a download URL for the existing document record without generating or regenerating anything. 404s if the report has not been generated yet.
     * Get a download URL for an already-generated report
     */
    async getGeneratedReportDownloadUrlRaw(requestParameters: GetGeneratedReportDownloadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateReport200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getGeneratedReportDownloadUrl.');
        }

        if (requestParameters.reportType === null || requestParameters.reportType === undefined) {
            throw new runtime.RequiredError('reportType','Required parameter requestParameters.reportType was null or undefined when calling getGeneratedReportDownloadUrl.');
        }

        const queryParameters: any = {};

        if (requestParameters.checkId !== undefined) {
            queryParameters['check_id'] = requestParameters.checkId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/generated-reports/{report_type}/download-url`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"report_type"}}`, encodeURIComponent(String(requestParameters.reportType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateReport200ResponseFromJSON(jsonValue));
    }

    /**
     * Signs and returns a download URL for the existing document record without generating or regenerating anything. 404s if the report has not been generated yet.
     * Get a download URL for an already-generated report
     */
    async getGeneratedReportDownloadUrl(requestParameters: GetGeneratedReportDownloadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateReport200Response> {
        const response = await this.getGeneratedReportDownloadUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deprecated. Use /leads/{lead_id}/generated-reports/{report_type} instead.
     * Get s offender records report for a screener lead
     * @deprecated
     */
    async generateSOffenderRecordsReportRaw(requestParameters: GenerateSOffenderRecordsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateSOffenderRecordsReport200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling generateSOffenderRecordsReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/s-offender-records/report`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateSOffenderRecordsReport200ResponseFromJSON(jsonValue));
    }

    /**
     * Deprecated. Use /leads/{lead_id}/generated-reports/{report_type} instead.
     * Get s offender records report for a screener lead
     * @deprecated
     */
    async generateSOffenderRecordsReport(requestParameters: GenerateSOffenderRecordsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateSOffenderRecordsReport200Response> {
        const response = await this.generateSOffenderRecordsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a ready-to-use object the demographics form can use as initial values. Backend merges AI-normalized lead info with the latest PCC patient record (when one exists). Users can still change any field.
     * Get pre-resolved PCC demographics prefill for a lead
     */
    async getPccDemographicsPrefillRaw(requestParameters: GetPccDemographicsPrefillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPccDemographicsPrefill200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getPccDemographicsPrefill.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/pcc/demographics-prefill`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPccDemographicsPrefill200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a ready-to-use object the demographics form can use as initial values. Backend merges AI-normalized lead info with the latest PCC patient record (when one exists). Users can still change any field.
     * Get pre-resolved PCC demographics prefill for a lead
     */
    async getPccDemographicsPrefill(requestParameters: GetPccDemographicsPrefillRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPccDemographicsPrefill200Response> {
        const response = await this.getPccDemographicsPrefillRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get PCC picklist options for a lead\'s facility
     */
    async getPccPicklistRaw(requestParameters: GetPccPicklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPccPicklist200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling getPccPicklist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/pcc/picklist`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPccPicklist200ResponseFromJSON(jsonValue));
    }

    /**
     * Get PCC picklist options for a lead\'s facility
     */
    async getPccPicklist(requestParameters: GetPccPicklistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPccPicklist200Response> {
        const response = await this.getPccPicklistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Ignore duplicate check for a screener lead by ID
     */
    async ignoreDuplicateCheckForLeadRaw(requestParameters: IgnoreDuplicateCheckForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling ignoreDuplicateCheckForLead.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/ignore-duplicate-check`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Ignore duplicate check for a screener lead by ID
     */
    async ignoreDuplicateCheckForLead(requestParameters: IgnoreDuplicateCheckForLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.ignoreDuplicateCheckForLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List auto-allocation assignment rules
     */
    async listAssignmentRulesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssignmentRules200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/assignment-rules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssignmentRules200ResponseFromJSON(jsonValue));
    }

    /**
     * List auto-allocation assignment rules
     */
    async listAssignmentRules(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssignmentRules200Response> {
        const response = await this.listAssignmentRulesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Patch PCC patient demographics after acceptance
     */
    async patchPccDemographicsRaw(requestParameters: PatchPccDemographicsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatchPccDemographics200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling patchPccDemographics.');
        }

        if (requestParameters.patchPccDemographicsRequest === null || requestParameters.patchPccDemographicsRequest === undefined) {
            throw new runtime.RequiredError('patchPccDemographicsRequest','Required parameter requestParameters.patchPccDemographicsRequest was null or undefined when calling patchPccDemographics.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/pcc/demographics`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchPccDemographicsRequestToJSON(requestParameters.patchPccDemographicsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatchPccDemographics200ResponseFromJSON(jsonValue));
    }

    /**
     * Patch PCC patient demographics after acceptance
     */
    async patchPccDemographics(requestParameters: PatchPccDemographicsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatchPccDemographics200Response> {
        const response = await this.patchPccDemographicsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the existing generated-document records for a lead without generating anything (no side effects).
     * List a screener lead\'s generated document records
     */
    async listGeneratedReportsRaw(requestParameters: ListGeneratedReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListGeneratedReports200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling listGeneratedReports.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/generated-reports`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListGeneratedReports200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the existing generated-document records for a lead without generating anything (no side effects).
     * List a screener lead\'s generated document records
     */
    async listGeneratedReports(requestParameters: ListGeneratedReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListGeneratedReports200Response> {
        const response = await this.listGeneratedReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Readmit a hospitalized resident to a facility
     */
    async readmitToFacilityRaw(requestParameters: ReadmitToFacilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReadmitToFacility200Response>> {
        if (requestParameters.readmitToFacilityRequest === null || requestParameters.readmitToFacilityRequest === undefined) {
            throw new runtime.RequiredError('readmitToFacilityRequest','Required parameter requestParameters.readmitToFacilityRequest was null or undefined when calling readmitToFacility.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/readmit-to-facility`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReadmitToFacilityRequestToJSON(requestParameters.readmitToFacilityRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadmitToFacility200ResponseFromJSON(jsonValue));
    }

    /**
     * Readmit a hospitalized resident to a facility
     */
    async readmitToFacility(requestParameters: ReadmitToFacilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReadmitToFacility200Response> {
        const response = await this.readmitToFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reorder auto-allocation assignment rules
     */
    async reorderAssignmentRulesRaw(requestParameters: ReorderAssignmentRulesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListAssignmentRules200Response>> {
        if (requestParameters.reorderAssignmentRulesRequest === null || requestParameters.reorderAssignmentRulesRequest === undefined) {
            throw new runtime.RequiredError('reorderAssignmentRulesRequest','Required parameter requestParameters.reorderAssignmentRulesRequest was null or undefined when calling reorderAssignmentRules.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/assignment-rules/reorder`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ReorderAssignmentRulesRequestToJSON(requestParameters.reorderAssignmentRulesRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListAssignmentRules200ResponseFromJSON(jsonValue));
    }

    /**
     * Reorder auto-allocation assignment rules
     */
    async reorderAssignmentRules(requestParameters: ReorderAssignmentRulesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListAssignmentRules200Response> {
        const response = await this.reorderAssignmentRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return an LOA resident to the facility
     */
    async returnToFacilityRaw(requestParameters: ReturnToFacilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling returnToFacility.');
        }

        if (requestParameters.returnToFacilityRequest === null || requestParameters.returnToFacilityRequest === undefined) {
            throw new runtime.RequiredError('returnToFacilityRequest','Required parameter requestParameters.returnToFacilityRequest was null or undefined when calling returnToFacility.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/return-to-facility`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReturnToFacilityRequestToJSON(requestParameters.returnToFacilityRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Return an LOA resident to the facility
     */
    async returnToFacility(requestParameters: ReturnToFacilityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.returnToFacilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revert the admission status to a previous one of a screener lead by ID
     */
    async revertAdmissionStatusByIdRaw(requestParameters: RevertAdmissionStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling revertAdmissionStatusById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/admission-status/revert`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Revert the admission status to a previous one of a screener lead by ID
     */
    async revertAdmissionStatusById(requestParameters: RevertAdmissionStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.revertAdmissionStatusByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bulk-replace assignments for a referral (Owner + Liaisons) atomically
     */
    async setLeadAssignmentsRaw(requestParameters: SetLeadAssignmentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetLeadAssignments200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling setLeadAssignments.');
        }

        if (requestParameters.setLeadAssignmentsRequest === null || requestParameters.setLeadAssignmentsRequest === undefined) {
            throw new runtime.RequiredError('setLeadAssignmentsRequest','Required parameter requestParameters.setLeadAssignmentsRequest was null or undefined when calling setLeadAssignments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/assignments`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetLeadAssignmentsRequestToJSON(requestParameters.setLeadAssignmentsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetLeadAssignments200ResponseFromJSON(jsonValue));
    }

    /**
     * Bulk-replace assignments for a referral (Owner + Liaisons) atomically
     */
    async setLeadAssignments(requestParameters: SetLeadAssignmentsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetLeadAssignments200Response> {
        const response = await this.setLeadAssignmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return a rule suggestion
     */
    async suggestionRaw(requestParameters: SuggestionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Suggestion200Response>> {
        if (requestParameters.suggestionRequest === null || requestParameters.suggestionRequest === undefined) {
            throw new runtime.RequiredError('suggestionRequest','Required parameter requestParameters.suggestionRequest was null or undefined when calling suggestion.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/criteria/suggestion`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SuggestionRequestToJSON(requestParameters.suggestionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Suggestion200ResponseFromJSON(jsonValue));
    }

    /**
     * Return a rule suggestion
     */
    async suggestion(requestParameters: SuggestionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Suggestion200Response> {
        const response = await this.suggestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Trigger a screener lead s. offender sync by ID
     */
    async syncLeadSOffenderRecordsByIdRaw(requestParameters: SyncLeadSOffenderRecordsByIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindSOffenderRecordsForLead200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling syncLeadSOffenderRecordsById.');
        }

        if (requestParameters.syncLeadSOffenderRecordsByIdRequest === null || requestParameters.syncLeadSOffenderRecordsByIdRequest === undefined) {
            throw new runtime.RequiredError('syncLeadSOffenderRecordsByIdRequest','Required parameter requestParameters.syncLeadSOffenderRecordsByIdRequest was null or undefined when calling syncLeadSOffenderRecordsById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/s-offender-records/sync`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SyncLeadSOffenderRecordsByIdRequestToJSON(requestParameters.syncLeadSOffenderRecordsByIdRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindSOffenderRecordsForLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Trigger a screener lead s. offender sync by ID
     */
    async syncLeadSOffenderRecordsById(requestParameters: SyncLeadSOffenderRecordsByIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindSOffenderRecordsForLead200Response> {
        const response = await this.syncLeadSOffenderRecordsByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unclaim a screener lead by ID
     */
    async unclaimLeadByIdRaw(requestParameters: UnclaimLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling unclaimLeadById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/leads/{lead_id}/unclaim`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Unclaim a screener lead by ID
     */
    async unclaimLeadById(requestParameters: UnclaimLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.unclaimLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the admission status of a screener lead by ID
     */
    async updateAdmissionStatusByIdRaw(requestParameters: UpdateAdmissionStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling updateAdmissionStatusById.');
        }

        if (requestParameters.updateAdmissionStatusRequest === null || requestParameters.updateAdmissionStatusRequest === undefined) {
            throw new runtime.RequiredError('updateAdmissionStatusRequest','Required parameter requestParameters.updateAdmissionStatusRequest was null or undefined when calling updateAdmissionStatusById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/admission-status`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAdmissionStatusRequestToJSON(requestParameters.updateAdmissionStatusRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Update the admission status of a screener lead by ID
     */
    async updateAdmissionStatusById(requestParameters: UpdateAdmissionStatusByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.updateAdmissionStatusByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an auto-allocation assignment rule
     */
    async updateAssignmentRuleRaw(requestParameters: UpdateAssignmentRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateAssignmentRule201Response>> {
        if (requestParameters.ruleId === null || requestParameters.ruleId === undefined) {
            throw new runtime.RequiredError('ruleId','Required parameter requestParameters.ruleId was null or undefined when calling updateAssignmentRule.');
        }

        if (requestParameters.updateAssignmentRuleRequest === null || requestParameters.updateAssignmentRuleRequest === undefined) {
            throw new runtime.RequiredError('updateAssignmentRuleRequest','Required parameter requestParameters.updateAssignmentRuleRequest was null or undefined when calling updateAssignmentRule.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/assignment-rules/{rule_id}`.replace(`{${"rule_id"}}`, encodeURIComponent(String(requestParameters.ruleId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateAssignmentRuleRequestToJSON(requestParameters.updateAssignmentRuleRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateAssignmentRule201ResponseFromJSON(jsonValue));
    }

    /**
     * Update an auto-allocation assignment rule
     */
    async updateAssignmentRule(requestParameters: UpdateAssignmentRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateAssignmentRule201Response> {
        const response = await this.updateAssignmentRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Make a decision on a screener lead by ID
     */
    async updateDecisionOnLeadByIdRaw(requestParameters: UpdateDecisionOnLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling updateDecisionOnLeadById.');
        }

        if (requestParameters.updateLeadDecisionRequest === null || requestParameters.updateLeadDecisionRequest === undefined) {
            throw new runtime.RequiredError('updateLeadDecisionRequest','Required parameter requestParameters.updateLeadDecisionRequest was null or undefined when calling updateDecisionOnLeadById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/decision`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLeadDecisionRequestToJSON(requestParameters.updateLeadDecisionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Make a decision on a screener lead by ID
     */
    async updateDecisionOnLeadById(requestParameters: UpdateDecisionOnLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.updateDecisionOnLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update screener integration settings for facility
     */
    async updateIntegrationSettingsByFacilityIdRaw(requestParameters: UpdateIntegrationSettingsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindOneIntegrationSettingsByFacilityId200Response>> {
        if (requestParameters.facilityId === null || requestParameters.facilityId === undefined) {
            throw new runtime.RequiredError('facilityId','Required parameter requestParameters.facilityId was null or undefined when calling updateIntegrationSettingsByFacilityId.');
        }

        if (requestParameters.integrationSettings === null || requestParameters.integrationSettings === undefined) {
            throw new runtime.RequiredError('integrationSettings','Required parameter requestParameters.integrationSettings was null or undefined when calling updateIntegrationSettingsByFacilityId.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/facilities/{facility_id}/integrations/settings`.replace(`{${"facility_id"}}`, encodeURIComponent(String(requestParameters.facilityId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationSettingsToJSON(requestParameters.integrationSettings),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindOneIntegrationSettingsByFacilityId200ResponseFromJSON(jsonValue));
    }

    /**
     * Update screener integration settings for facility
     */
    async updateIntegrationSettingsByFacilityId(requestParameters: UpdateIntegrationSettingsByFacilityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindOneIntegrationSettingsByFacilityId200Response> {
        const response = await this.updateIntegrationSettingsByFacilityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reassign an existing assignment to a different user
     */
    async updateLeadAssignmentRaw(requestParameters: UpdateLeadAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadAssignment200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling updateLeadAssignment.');
        }

        if (requestParameters.assignmentId === null || requestParameters.assignmentId === undefined) {
            throw new runtime.RequiredError('assignmentId','Required parameter requestParameters.assignmentId was null or undefined when calling updateLeadAssignment.');
        }

        if (requestParameters.updateLeadAssignmentRequest === null || requestParameters.updateLeadAssignmentRequest === undefined) {
            throw new runtime.RequiredError('updateLeadAssignmentRequest','Required parameter requestParameters.updateLeadAssignmentRequest was null or undefined when calling updateLeadAssignment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/assignments/{assignment_id}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))).replace(`{${"assignment_id"}}`, encodeURIComponent(String(requestParameters.assignmentId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLeadAssignmentRequestToJSON(requestParameters.updateLeadAssignmentRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadAssignment200ResponseFromJSON(jsonValue));
    }

    /**
     * Reassign an existing assignment to a different user
     */
    async updateLeadAssignment(requestParameters: UpdateLeadAssignmentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadAssignment200Response> {
        const response = await this.updateLeadAssignmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a screener lead by ID
     */
    async updateLeadByIdRaw(requestParameters: UpdateLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling updateLeadById.');
        }

        if (requestParameters.lead === null || requestParameters.lead === undefined) {
            throw new runtime.RequiredError('lead','Required parameter requestParameters.lead was null or undefined when calling updateLeadById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LeadToJSON(requestParameters.lead),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener lead by ID
     */
    async updateLeadById(requestParameters: UpdateLeadByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.updateLeadByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a screener lead comment by ID
     */
    async updateLeadCommentByIdRaw(requestParameters: UpdateLeadCommentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLeadComment201Response>> {
        if (requestParameters.commentId === null || requestParameters.commentId === undefined) {
            throw new runtime.RequiredError('commentId','Required parameter requestParameters.commentId was null or undefined when calling updateLeadCommentById.');
        }

        if (requestParameters.leadComment === null || requestParameters.leadComment === undefined) {
            throw new runtime.RequiredError('leadComment','Required parameter requestParameters.leadComment was null or undefined when calling updateLeadCommentById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/lead-comments/{comment_id}`.replace(`{${"comment_id"}}`, encodeURIComponent(String(requestParameters.commentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: LeadCommentToJSON(requestParameters.leadComment),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLeadComment201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener lead comment by ID
     */
    async updateLeadCommentById(requestParameters: UpdateLeadCommentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLeadComment201Response> {
        const response = await this.updateLeadCommentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a lead s. offender record by ID
     */
    async updateLeadSOffenderRecordByIdRaw(requestParameters: UpdateLeadSOffenderRecordByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateLeadSOffenderRecordById200Response>> {
        if (requestParameters.sOffenderRecordId === null || requestParameters.sOffenderRecordId === undefined) {
            throw new runtime.RequiredError('sOffenderRecordId','Required parameter requestParameters.sOffenderRecordId was null or undefined when calling updateLeadSOffenderRecordById.');
        }

        if (requestParameters.updateLeadSOffenderRecordRequest === null || requestParameters.updateLeadSOffenderRecordRequest === undefined) {
            throw new runtime.RequiredError('updateLeadSOffenderRecordRequest','Required parameter requestParameters.updateLeadSOffenderRecordRequest was null or undefined when calling updateLeadSOffenderRecordById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/s-offender-records/{s_offender_record_id}`.replace(`{${"s_offender_record_id"}}`, encodeURIComponent(String(requestParameters.sOffenderRecordId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLeadSOffenderRecordRequestToJSON(requestParameters.updateLeadSOffenderRecordRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateLeadSOffenderRecordById200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a lead s. offender record by ID
     */
    async updateLeadSOffenderRecordById(requestParameters: UpdateLeadSOffenderRecordByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateLeadSOffenderRecordById200Response> {
        const response = await this.updateLeadSOffenderRecordByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update the previous stay in facility status of a screener lead by ID
     */
    async updatePreviousStayByIdRaw(requestParameters: UpdatePreviousStayByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLead201Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling updatePreviousStayById.');
        }

        if (requestParameters.updatePreviousStayRequest === null || requestParameters.updatePreviousStayRequest === undefined) {
            throw new runtime.RequiredError('updatePreviousStayRequest','Required parameter requestParameters.updatePreviousStayRequest was null or undefined when calling updatePreviousStayById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/previous-stay`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePreviousStayRequestToJSON(requestParameters.updatePreviousStayRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLead201ResponseFromJSON(jsonValue));
    }

    /**
     * Update the previous stay in facility status of a screener lead by ID
     */
    async updatePreviousStayById(requestParameters: UpdatePreviousStayByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLead201Response> {
        const response = await this.updatePreviousStayByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a screener source by ID
     */
    async updateSourceByIdRaw(requestParameters: UpdateSourceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSource201Response>> {
        if (requestParameters.sourceId === null || requestParameters.sourceId === undefined) {
            throw new runtime.RequiredError('sourceId','Required parameter requestParameters.sourceId was null or undefined when calling updateSourceById.');
        }

        if (requestParameters.source === null || requestParameters.source === undefined) {
            throw new runtime.RequiredError('source','Required parameter requestParameters.source was null or undefined when calling updateSourceById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/sources/{source_id}`.replace(`{${"source_id"}}`, encodeURIComponent(String(requestParameters.sourceId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SourceToJSON(requestParameters.source),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSource201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener source by ID
     */
    async updateSourceById(requestParameters: UpdateSourceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSource201Response> {
        const response = await this.updateSourceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a screener source contact by ID
     */
    async updateSourceContactByIdRaw(requestParameters: UpdateSourceContactByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateSourceContact201Response>> {
        if (requestParameters.contactId === null || requestParameters.contactId === undefined) {
            throw new runtime.RequiredError('contactId','Required parameter requestParameters.contactId was null or undefined when calling updateSourceContactById.');
        }

        if (requestParameters.sourceContact === null || requestParameters.sourceContact === undefined) {
            throw new runtime.RequiredError('sourceContact','Required parameter requestParameters.sourceContact was null or undefined when calling updateSourceContactById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/source-contacts/{contact_id}`.replace(`{${"contact_id"}}`, encodeURIComponent(String(requestParameters.contactId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SourceContactToJSON(requestParameters.sourceContact),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateSourceContact201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a screener source contact by ID
     */
    async updateSourceContactById(requestParameters: UpdateSourceContactByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateSourceContact201Response> {
        const response = await this.updateSourceContactByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update special criteria by ID
     */
    async updateSpecialCriteriaByIdRaw(requestParameters: UpdateSpecialCriteriaByIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateSpecialCriteriaById200Response>> {
        if (requestParameters.criteriaId === null || requestParameters.criteriaId === undefined) {
            throw new runtime.RequiredError('criteriaId','Required parameter requestParameters.criteriaId was null or undefined when calling updateSpecialCriteriaById.');
        }

        if (requestParameters.updateSpecialCriteriaByIdRequest === null || requestParameters.updateSpecialCriteriaByIdRequest === undefined) {
            throw new runtime.RequiredError('updateSpecialCriteriaByIdRequest','Required parameter requestParameters.updateSpecialCriteriaByIdRequest was null or undefined when calling updateSpecialCriteriaById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/special-criteria/{criteria_id}`.replace(`{${"criteria_id"}}`, encodeURIComponent(String(requestParameters.criteriaId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSpecialCriteriaByIdRequestToJSON(requestParameters.updateSpecialCriteriaByIdRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateSpecialCriteriaById200ResponseFromJSON(jsonValue));
    }

    /**
     * Update special criteria by ID
     */
    async updateSpecialCriteriaById(requestParameters: UpdateSpecialCriteriaByIdOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateSpecialCriteriaById200Response> {
        const response = await this.updateSpecialCriteriaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a PCC advanced patient\'s details
     */
    async uploadPccAdvancedPatientDetailsRaw(requestParameters: UploadPccAdvancedPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadPccAdvancedPatientDetails200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling uploadPccAdvancedPatientDetails.');
        }

        if (requestParameters.pccAdvancedPatientDetails === null || requestParameters.pccAdvancedPatientDetails === undefined) {
            throw new runtime.RequiredError('pccAdvancedPatientDetails','Required parameter requestParameters.pccAdvancedPatientDetails was null or undefined when calling uploadPccAdvancedPatientDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/pcc/patient/details/advanced`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PccAdvancedPatientDetailsToJSON(requestParameters.pccAdvancedPatientDetails),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadPccAdvancedPatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Upload a PCC advanced patient\'s details
     */
    async uploadPccAdvancedPatientDetails(requestParameters: UploadPccAdvancedPatientDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadPccAdvancedPatientDetails200Response> {
        const response = await this.uploadPccAdvancedPatientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a PCC patient\'s details
     */
    async uploadPccPatientDetailsRaw(requestParameters: UploadPccPatientDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadPccPatientDetails200Response>> {
        if (requestParameters.leadId === null || requestParameters.leadId === undefined) {
            throw new runtime.RequiredError('leadId','Required parameter requestParameters.leadId was null or undefined when calling uploadPccPatientDetails.');
        }

        if (requestParameters.uploadPccPatientDetailsRequest === null || requestParameters.uploadPccPatientDetailsRequest === undefined) {
            throw new runtime.RequiredError('uploadPccPatientDetailsRequest','Required parameter requestParameters.uploadPccPatientDetailsRequest was null or undefined when calling uploadPccPatientDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/leads/{lead_id}/pcc/patient/details`.replace(`{${"lead_id"}}`, encodeURIComponent(String(requestParameters.leadId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadPccPatientDetailsRequestToJSON(requestParameters.uploadPccPatientDetailsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadPccPatientDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Upload a PCC patient\'s details
     */
    async uploadPccPatientDetails(requestParameters: UploadPccPatientDetailsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadPccPatientDetails200Response> {
        const response = await this.uploadPccPatientDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const FindAllLeadsReviewStageAcceptSourceEnum = {
    Automated: 'automated',
    Manual: 'manual'
} as const;
export type FindAllLeadsReviewStageAcceptSourceEnum = typeof FindAllLeadsReviewStageAcceptSourceEnum[keyof typeof FindAllLeadsReviewStageAcceptSourceEnum];
